import React from 'react';
import { Link } from 'react-router-dom';
import './welcomePage.css'; 

const WelcomePage = () => {
  return (
<div className="welcome-wrapper">
  <div className="welcome-container">
    <h1 className="welcome-title">فولاد فام مشرق</h1>
    <div className="button-container">
      <Link to="/tehran" className="welcome-btn">
        تهران
      </Link>
      <Link to="/factory" className="welcome-btn">
        کارخانه
      </Link>
      <Link to="/isfahan" className="welcome-btn">
        اصفهان
      </Link>
      <Link to="/miscellaneous" className="welcome-btn">
        متفرقه
      </Link>
    </div>
  </div>
</div>

  );
};

export default WelcomePage;